import { BlockBoundary } from '@shared/lib/components/BlockBoundary'
import { Modal } from '@shared/ui/Overlays/Modal'
import s from './Modals.module.sass'
import Img from '@images/restorator/materials.webp'
import Image from 'next/image'
import { Text } from '@shared/ui/Typography/Text'

interface Props {
  active: boolean
  onClose: () => void
}

export const MaterialsModal = ({ active, onClose }: Props) => {
  return (
    <>
      {active && (
        <BlockBoundary>
          <Modal
            title='Редакционные материалы'
            handleClose={onClose}
            titleSizes='h1 h3'
            size='S'
            className={s.bottomless}
            mobileShadowless={true}>
            <div className={s.content}>
              <Text sizes='ML M' className={s['text-content']}>
                <ul>
                  <li> Партнерский материал на сайте (статья / новость /&nbsp;интервью)</li>

                  <li> Участие в&nbsp;подборке «Планы&nbsp;на&nbsp;неделю»</li>
                </ul>
              </Text>

              <Image src={Img.src} alt='Промо' width={255} height={374} quality={100} />
            </div>
          </Modal>
        </BlockBoundary>
      )}
    </>
  )
}
